module.exports = __webpack_public_path__ + "img/16.90ceaabe.jpg";